import React from 'react';
import { observer } from 'mobx-react-lite';
import { useInputValueChangingFunctions } from '@pascal/pascal-core';
import { InputTypesForChanging } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { freeBetStore } from '@pascal/pascal-core/shared/core/store/freeBetStore';
import { betDataStore, gameStore } from '../../../../store';
import { useAmountValidation } from '../../../../helpers/useAmountValidation';
import { QuickBtn } from '../../../../components/common/bettingPart';
import { BetAmountInput } from '../../../../components/common/bettingPart';
import { minOddConstant, minOddStep } from '../../../../enums/gameConstants';

export const BetAmount = observer(({ t, handleOpenNumPad }) => {
  const { setBetAmount, betsSectionsData, setAutoCashOutOdd } = betDataStore;
  const { activeGameType } = gameStore;
  const { limits } = gameConfigStore;
  const { betAmount, isAutoBet, isAutoCashOut, autoCashOutOdd } = betsSectionsData[activeGameType];
  const { activeFreeBet } = freeBetStore;

  const { handleChangeInputValue } = useInputValueChangingFunctions({
    additionalInputInfo: { inputType: InputTypesForChanging.BetInput },
    changingValue: betAmount,
    changingValueCallback: setBetAmount,
    autoCashOutData: {
      isAutoCashOut,
      minOdd: activeFreeBet.id ? activeFreeBet.minOdd : minOddConstant,
      minOddStep,
      autoCashOutOdd: Number(autoCashOutOdd),
      updateAutoCashOutValue: setAutoCashOutOdd,
    },
    autoCashOutValueChangingCallback: setAutoCashOutOdd,
  });

  const { onChange: handleChangeAmount } = useAmountValidation(setBetAmount, limits);
  return (
    <div className={`game-bet-block left-cl  ${isAutoBet || activeFreeBet.id ? 'disabled' : ''}`}>
      <div className='game-bet-bl-main-box'>
        <BetAmountInput
          handleChangeInputValue={handleChangeInputValue}
          betAmount={betAmount}
          isAutoBet={isAutoBet}
          handleOpenNumPad={handleOpenNumPad}
          handleChangeAmount={handleChangeAmount}
        />
        <QuickBtn
          handleChangeInputValue={handleChangeInputValue}
          betAmount={betAmount}
          limits={limits}
          t={t}
        />
      </div>
    </div>
  );
});
